import React, { Component, memo, useContext, useEffect, useState } from 'react';
import { FilterType, GridComponent } from '@syncfusion/ej2-react-grids';
import { BsSearch } from 'react-icons/bs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import GlobalGrid from '../../components/GlobalGrid';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { ThemeContext } from '../../context/theme.context';
interface IProps {
  outter_asset_code?: string;
  first_load_request?: any;
}
var gridmntObj: GridComponent;
var theQueryOutterAsset = '';
var theQuerySearch = '';
var current_query: string = '';
var resultLikeQuery = '';
const theColumns = [
  { field: 'Asset_Number', text: 'Asset Number', width: 140 },
  { field: 'plt_pm_task_no', text: 'PM Task Number', width: 140 },
  {
    field: 'plt_pm_task_text',
    text: 'PM Description',
    allowEditing: true,
    width: 140,
  },
  { field: 'Site', text: 'Site', width: 140 },
  {
    field: 'Last_Reading_Date',
    text: 'Last Reading Date',
    width: 140,
    type: 'datetime',
    format: 'dd/MM/yyyy HH:mm',
  },
  { field: 'Average', text: 'Average', width: 140 },
  { field: 'Current_Reading', text: 'Current Reading', width: 140 },
  { field: 'Alltime_Reading', text: 'Alltime Reading', width: 140 },
  { field: 'Work_Order', text: 'Work Order', width: 140 },
  { field: 'Current_Schedule', text: 'Current Schedule', width: 140 },
  { field: 'pronto_row_id', text: 'row_id', width: 140 },
  { field: 'Monitor_Point', text: 'Monitor Point', width: 140 },
  { field: 'Next_Due_Value', text: 'Next Due Value', width: 140 },
  { field: 'Number_of_Readings', text: 'Number of Readings', width: 140 },
  {
    field: 'PM_End_Date',
    text: 'PM End Date',
    width: 140,
    type: 'datetime',
    format: 'dd/MM/yyyy HH:mm',
  },
  {
    field: 'PM_Last_Done',
    text: 'PM Last Done',
    width: 140,
    type: 'datetime',
    format: 'dd/MM/yyyy HH:mm',
  },
  { field: 'UOM', text: 'UOM' },
  {
    field: 'pm_labour_type_1',
    headerText: 'Trade1',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'pm_labour_qty_1',
    headerText: 'Qty1',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'est_hours_1',
    headerText: 'Est1',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'pm_labour_type_2',
    headerText: 'Trade2',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'pm_labour_qty_2',
    headerText: 'Qty2',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'est_hours_2',
    headerText: 'Est2',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'pm_labour_type_3',
    headerText: 'Trade3',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'pm_labour_qty_3',
    headerText: 'Qty3',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'est_hours_3',
    headerText: 'Est3',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'pm_labour_type_4',
    headerText: 'Trade4',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'pm_labour_qty_4',
    headerText: 'Qty4',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'est_hours_4',
    headerText: 'Est4',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'pm_section_code',
    headerText: 'Section',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'plt_pm_frequency',
    headerText: 'Frequency',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  {
    field: 'plt_pm_priority',
    headerText: 'Priority',
    textAlign: 'Left',
    allowEditing: true,
    width: 140,
  },
  { field: 'code', text: 'Responsible', allowEditing: true, width: 140 },
  {
    field: 'S_Material_Cost',
    headerText: 'S_Material_Cost',
    allowEditing: false,
    format: 'C2',
    width: 140,
  },
  {
    field: 'S_Labour_Cost',
    textAlign: 'Left',
    headerText: 'S_Labour_Cost',
    allowEditing: false,
    format: 'C2',
    width: 140,
  },
  {
    field: 'S_Other_Cost',
    textAlign: 'Left',
    headerText: 'S_Other_Cost',
    allowEditing: false,
    format: 'C2',
    width: 140,
  },
  {
    field: 'T_Material_Cost',
    headerText: 'T_Material_Cost',
    editType: 'numericedit',
    allowEditing: true,
    format: 'C2',
    width: 140,
  },
  {
    field: 'T_Labour_Cost',
    textAlign: 'Left',
    headerText: 'T_Labour_Cost',
    editType: 'numericedit',
    allowEditing: true,
    format: 'C2',
    width: 140,
  },
  {
    field: 'T_Other_Cost',
    textAlign: 'Left',
    headerText: 'T_Other_Cost',
    editType: 'numericedit',
    allowEditing: true,
    format: 'C2',
    width: 140,
  },
  {
    field: 'total',
    textAlign: 'Left',
    headerText: 'Total',
    format: 'C2',
    allowEditing: false,
    width: 140,
  },
];
var searchText: string = '';
const AssetStrategies = ({ outter_asset_code, first_load_request }: IProps) => {
  const [the_current_query, setThe_current_query] = useState('');
  const [signalOfLoad, setSignalOfLoad] = useState(false);
  const context = useContext(ThemeContext);
  const buildQuery = () => {
    current_query = current_query.trimEnd();
    current_query = current_query.replace(theQueryOutterAsset, '');
    current_query = current_query.replace(theQuerySearch, '');
    var o_asset_code = outter_asset_code;
    if (o_asset_code !== '' && o_asset_code !== undefined) {
      if (current_query !== '') {
        theQueryOutterAsset = addToQuery(
          'Asset_Number',
          'in',
          'andWhere',
          o_asset_code.trim(),
          theQueryOutterAsset
        );
      } else {
        theQueryOutterAsset = addToQuery(
          'Asset_Number',
          'in',
          'where',
          o_asset_code.trim(),
          theQueryOutterAsset
        );
      }
    }
    if (searchText !== '' && searchText) {
      theQuerySearch = '$' + searchText;
      current_query = current_query + theQuerySearch;
    }
    setSignalOfLoad(true);
    setThe_current_query(current_query + ' ');
  };
  const addToQuery = (
    field: string,
    c: string,
    type: string,
    v: string,
    the_current_query: string
  ) => {
    the_current_query = JSON.stringify({
      f: field,
      c: c,
      t: type,
      v: v,
    });
    the_current_query += '?';
    current_query += the_current_query;
    return the_current_query;
  };
  const template = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'flex-end',
          height: 25,
        }}
      >
        <TextBoxComponent
          type={'text'}
          id='asset-strategy'
          autocomplete='off'
          input={inputEnterPress.bind(this)}
          showClearButton
          placeholder='Search'
          value={searchText}
          onChange={(args: any) => {
            searchText = args.target.value;
          }}
        />
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <BsSearch
            color={context.isDarkMode ? '#eaeaea' : '#292525'}
            className={'searchIcon'}
            onClick={search.bind(this)}
          />
        </div>
      </div>
    );
  };
  const templateMenuEl = () => {
    return (
      <div>
        <DropDownListComponent
          id='ddlelement'
          dataSource={[
            { text: 'Menu', value: 'Menu' },
            { text: 'Checkbox', value: 'CheckBox' },
            { text: 'Excel', value: 'Excel' },
          ]}
          fields={{ text: 'text', value: 'value' }}
          change={onChange.bind(this)}
          index={0}
          popupHeight='150px'
          width='200px'
        />
      </div>
    );
  };
  const gotoAttachments = () => {
    if (gridmntObj.getSelectedRecords().length > 0) {
      window.open(
        'https://builder.onplan.app/uploaded_files/generated_reports/demo-job-report-2000249-Caterpillar-Truck-TR01-First-Quantum-Mineral-53750-pm.pdf',
        '_blank'
      );
    }
  };
  const templateButton = () => {
    return (
      <div style={{ marginLeft: '10px' }}>
        <ButtonComponent onClick={gotoAttachments.bind(this)}>
          Attachments
        </ButtonComponent>
      </div>
    );
  };
  const toolbarOptions: any = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    { template: templateMenuEl.bind(this) },
    { template: templateButton.bind(this) },
    { template: template, align: 'Right' },
  ];
  const inputEnterPress = (e: any) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      search();
    }
  };
  useEffect(() => {
    if (first_load_request) {
      buildQuery();
    }
  }, []);

  const onChange = (sel: {
    itemData: { text: string; value: string };
  }): void => {
    gridmntObj.filterSettings.type = sel.itemData.value as FilterType;
    gridmntObj.clearFiltering();
  };
  const removeSearch = () => {
    if (searchText !== '') {
      $('#asset_strategies').val('');
      if (resultLikeQuery !== '') {
        current_query = current_query.replace(resultLikeQuery, '');
        resultLikeQuery = '';
        setThe_current_query(current_query);
      }
    }
  };
  const search = () => {
    if (searchText !== '' || current_query !== '') {
      buildQuery();
    }
  };
  useEffect(() => {
    if (outter_asset_code) {
      buildQuery();
    }
  }, [outter_asset_code]);

  return (
    <div>
      <GlobalGrid
        columns={theColumns}
        height={'calc(-290px + 100vh)'}
        query={the_current_query}
        toolbarOptions={toolbarOptions}
        get_query={'asset-strg'}
        id={'asset-strategy-grid'}
        isFitInCOntent={false}
        edit_query={'asset_cost_master_edit'}
        signalOfLoad={signalOfLoad}
        gridRef={(ref) => (gridmntObj = ref)}
       
      />
    </div>
  );
};
export default React.memo(AssetStrategies);
